<template>
	<div class="section section-create">
		<div
			v-if="!isLastCreatedLinkToEdit && !linkCreated && !linkToEdit"
			class="section-title is-small"
		>
			Create a short link
		</div>
		<div
			v-if="isLastCreatedLinkToEdit"
			class="link-created-title"
		>
			<div class="section-title is-small">
				<img
					src="@/assets/check.png"
					alt="check"
				>
				Short link created
			</div>
			<AppButton
				color="primary"
				size="small"
				@click="clearData"
			>
				Create new link
			</AppButton>
		</div>
		<div
			v-if="!isLastCreatedLinkToEdit && !linkCreated && linkToEdit"
			class="link-created-title"
		>
			<div class="section-title is-small">
				Edit your short link
			</div>
			<AppButton
				color="primary"
				size="small"
				@click="clearData"
			>
				Create new link
			</AppButton>
		</div>
		<ValidationObserver
			v-if="!isLastCreatedLinkToEdit && !linkCreated && !linkToEdit"
			ref="observer"
			v-slot="{ valid, handleSubmit }"
			tag="form"
			class="form"
			@submit.prevent
		>
			<LinkPasteInput
				v-model="newLink"
				@submit="handleSubmit(onCreateLink)"
			/>
			<AppButton
				v-if="valid"
				color="primary"
				size="small"
				class="is-right"
				@click="handleSubmit(onCreateLink)"
			>
				Create Link
			</AppButton>
		</ValidationObserver>
	</div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import LinkPasteInput from '@/components/LinkPasteInput.vue';
import { mapActions, mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';

export default {
	name: 'WidgetCreate',

	components: {
		AppButton,
		LinkPasteInput,
		ValidationObserver,
	},

	data() {
		return {
			linkCreated: false,
			newLink: '',
		};
	},

	computed: {
		...mapGetters([
			'isLastCreatedLinkToEdit',
			'linkToEdit',
		]),
	},

	watch: {
		isLastCreatedLinkToEdit() {
			this.newLink = '';
		},
	},

	methods: {
		...mapActions([
			'createLink',
			'setLinkToEdit',
		]),
		async onCreateLink() {
			try {
				const link = await this.createLink(this.newLink);
				this.setLinkToEdit(link);
			} catch (error) {
				this.$notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
			}
		},
		clearData() {
			try {
				this.setLinkToEdit(null);
			} catch (error) {
				this.$notify({
					duration: 6000,
					type: 'error',
					title: '',
					text: 'oops! Something went wrong.',
				});
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.section-description {
	color: $color-accent-200;
}

.section-title {
	margin-bottom: $gap-3;
}

.section-create {
	display: flex;
	flex-direction: column;
	position: relative;
}

.close {
	cursor: pointer;
}

.items {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 2px solid $color-accent-400;
	transition: all 275ms ease-in-out;
	cursor: text;

	&:hover {
		border-bottom: 2px solid $color-accent-300;
	}
}

.link-created-title {
	display: flex;
	justify-content: space-between;
}

.is-right {
	display: flex;
	justify-content: flex-end;
	margin-top: $gap-3;
}

.button {
	cursor: pointer;
}

.link-details {
	overflow: auto;
}

.detail-items {
	display: flex;
	width: 100%;

	.item {
		width: 100%;
		margin-top: $gap-3;

		&:last-child {
			margin-right: 0;
		}
	}
}
</style>
